import React from 'react'

let TextField, Input, DatePicker, moment
const textFieldPromise = import(/* webpackChunkName: "textField" */ "@material/react-text-field")
const datePickerPromise = import(/* webpackChunkName: "datePicker" */ "react-datepicker")
const momentPromise = import(/* webpackChunkName: "momentTimezone" */ "moment-timezone")

export class MDCDDateInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showDatePicker: this.props.showPicker || false,
      dateValue: props.value || ''
    }
    this.waitForImports()

    this.inputRef = React.createRef()
    this.handleShowDatePicker = this.handleShowDatePicker.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleDateChange = this.handleDateChange.bind(this)

    if (props.takeFocus) {
      // When the calendar opens it takes focus.  Take focus back so user can type in a date if desired.
      setTimeout(() => {
        if (this.inputRef.current) {
          this.inputRef.current.inputElement.focus()
          this.inputRef.current.inputElement.select()
        }
      }, 100)
    }
  }

  async waitForImports() {
    TextField = (await textFieldPromise).default
    Input = (await textFieldPromise).Input
    DatePicker = (await datePickerPromise).default
    moment = (await momentPromise).default
    this.setState({loaded: true})
  }

  componentDidUpdate() {
    if (this.props.value !== this.state.dateValue) {
      this.setState({dateValue: this.props.value})
    }
  }

  getDateFormat() {
    if (this.props.dateFormat) {
      return this.props.dateFormat
    }
    return "MM/DD/YY"
  }

  handleShowDatePicker(event) {
    event.preventDefault()

    const shouldShow = !this.state.showDatePicker
    this.setState({showDatePicker: shouldShow})
  }

  handleDateChange(event) {
    const newDate = moment(event).format(this.getDateFormat())
    let showDatePicker = true
    if (this.props.closeOnSelect) {
      showDatePicker = false
    }
    this.setState({dateValue: newDate, showDatePicker: showDatePicker})
    if (this.props.onChange) {
      this.props.onChange({target: {value: newDate}})
    }
  }

  handleInputChange(event) {
    this.setState({showDatePicker: false, dateValue: event.target.value})
    if (this.props.onChange) {
      this.props.onChange({target: {value: event.target.value}})
    }
  }

  getPlaceholder() {
    if (!this.state.showDatePicker) {
      return ""
    }
    if (this.props.placeholder) {
      return this.props.placeholder
    }
    return this.getDateFormat()
  }

  render() {
    if (!this.state.loaded) {
      return null
    }
    const {label, inputClassName, textClassName, showTimeInput} = this.props
    let minDate = new Date()
    if (this.props.minDate !== undefined) {
      minDate = this.props.minDate
    }
    const selectedMoment = moment(this.state.dateValue, this.getDateFormat())

    const selectedDate = selectedMoment.isValid() ? !!this.props.endOfDay ? selectedMoment.endOf(
            'day').toDate() : selectedMoment.toDate() :
        !!this.props.defaultTime ? this.props.defaultTime : moment().startOf('day').add(1, 'ms').toDate()
    return (
        <div style={{width: '100%', height: '100%'}}>
          <TextField
              label={label}
              className={textClassName}
              outlined={this.props.outlined}
              dense={this.props.dense}
              helperText={this.props.helperText}
          >
            <Input
                ref={this.inputRef}
                className={inputClassName}
                value={this.state.dateValue}
                isValid={this.props.isValid}
                maxLength={this.props.dateFormat ? 20 : 8}
                onClick={this.handleShowDatePicker}
                onChange={this.handleInputChange}
                placeholder={this.getPlaceholder()}
                disabled={this.props.disabled}
                autoComplete={'off'}
            />
          </TextField>
          {this.state.showDatePicker &&
              <div style={{margin: '3px -50px', position: 'fixed', top: `${this.props.position}px`}}>
                <DatePicker
                    inline
                    formatWeekDay={(weekDay) => (weekDay.charAt(0))}
                    minDate={minDate}
                    maxDate={this.props.endDate}
                    showDisabledMonthNavigation
                    showTimeInput={showTimeInput}
                    timeFormat="HH:mm"
                    dateFormat={this.getDateFormat()}
                    disabledKeyboardNavigation={this.props.disabledKeyboardNavigation}
                    onChange={this.handleDateChange}
                    selected={selectedDate}
                />
              </div>
          }
        </div>
    )
  }
}